import { Component } from '@angular/core';

@Component({
  selector: 'app-subscription-add',
  templateUrl: './subscription-add.component.html',
  styleUrls: ['./subscription-add.component.scss'],
})
export class SubscriptionAddComponent {}
